const $window = $(window);
const $topLists: any = $('.js-top-list');

let lastBreakpoint;

const topList = {
  initialize() {
    if (!$topLists.length) {
      return;
    }

    this.createListeners();
    this.calcDimensions();
  },

  createListeners() {
    $window.on('resize', () => {
      this.calcDimensions();
    });
  },

  calcDimensions() {
    const newBreakpoint = $window.width() < 768 ? 'sm' : 'lg';

    if (newBreakpoint !== lastBreakpoint) {
      lastBreakpoint = newBreakpoint;
      this.create();
    }
  },

  create() {
    if (lastBreakpoint === 'sm') {
      $topLists.slick({
        slidesToShow: 3,
        arrows: false,
        responsive: [
          {
            breakpoint: 409,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    } else {
      $topLists.each((i, topList) => {
        const $topList: any = $(topList);
        if ($topList.hasClass('slick-slider')) {
          $topList.slick('unslick');
        }
      });
    }
  },
};

export default topList;
